module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.panelsDefinitionValues[0]) + " -- " + _vm._s(_vm.panelsDefinitionValues[1]) + "\n    "), _c('div', {
    staticStyle: {
      "width": "400px",
      "margin-left": "50px"
    },
    attrs: {
      "id": "EditCard"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-3"
  }, [_c('v-range-slider', {
    attrs: {
      "max": 100,
      "min": 0,
      "step": 1,
      "thumb-label": "always",
      "track-color": "green",
      "color": "yellow",
      "thumb-color": "blue"
    },
    model: {
      value: (_vm.panelsDefinitionValues),
      callback: function($$v) {
        _vm.panelsDefinitionValues = $$v
      },
      expression: "panelsDefinitionValues"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e24cbe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/PanelsDefinitionSelector.vue
// module id = 521
// module chunks = 0